import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=4728b5a4&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=4728b5a4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4728b5a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4728b5a4')) {
      api.createRecord('4728b5a4', component.options)
    } else {
      api.reload('4728b5a4', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=4728b5a4&scoped=true", function () {
      api.rerender('4728b5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/feedback/Feedback.vue"
export default component.exports